import { Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/Toaster';

/**
 * RootLayout - Top-level layout wrapper for the entire application
 * 
 * Provides:
 * - Global toast notifications
 * - Any app-wide providers would go here
 * - Outlet for nested routes
 */
export default function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
